<template>
    <flickity :options="flickityOptions" class="md:flex md:justify-end orsus-iphones">
        <div class="carousel-cell w-full md:w-auto md:px-12 relative">
            <img src="/assets/images/orsus_ecosystem-1.png" class="md:w-auto mb-6 md:mb-0 block i-phone hover:zoom z-10 relative mx-auto" alt="">
            <div class="md:absolute pin-l pin-y md:-translate-x-full my-auto flex flex-col items-center px-6 justify-center w-full">
                <img src="/assets/images/icons/iphone-line-1.svg" class="hidden md:block h-16 pin-y z-0 z-0 mb-6" alt="" style="transform: translateX(95%);">
                <h3 class="font-futura text-lg md:text-3xl">Talent Shows</h3>
            </div>
        </div>

        <div class="carousel-cell w-full md:w-auto md:px-12 relative flex flex-col-reverse md:block">
            <div class="md:absolute pin-l md:-translate-y-full flex flex-col items-center justify-center w-full">
                <h3 class="font-futura md:mb-8 text-lg md:text-3xl">IP Discovery</h3>
                <span class="h-16 w-px hidden md:block" style="background-color: #D6D6D6;"></span>
            </div>
            <img src="/assets/images/orsus_ecosystem-2.png" class="md:w-auto mb-6 md:mb-0 block i-phone hover:zoom mx-auto" alt="">
        </div>

        <div class="carousel-cell w-full md:w-auto md:px-12 md:pt-8 md:-translate-y-1/2 relative">
            <img src="/assets/images/orsus_ecosystem-3.png" class="md:w-auto mb-6 md:mb-0 block i-phone z-10 relative hover:zoom mx-auto" alt="">
            <div class="md:absolute pin-l translate-y-3/4 md:mt-12 flex flex-col items-center md:px-6 justify-center w-full">
                <h3 class="font-futura text-lg md:text-3xl text-center md:text-left">Personally <br>Owned Platforms (POPs)</h3>
                <img src="/assets/images/icons/iphone-line-3.svg" class="hidden md:block h-24 absolute pin-t pin-r z-0 mr-12 mt-6 -translate-y-full" alt="">
            </div>
        </div>
    </flickity>
</template>

<script>
import Flickity from 'vue-flickity';

export default {
    components: {
        Flickity
    },
    data() {
        return {
            flickityOptions: {
                watchCSS: true,
                prevNextButtons: false
            }
        }
    }
}
</script>
